export default "__VITE_ASSET__Bp$QzBLK__"